import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import noop from 'lodash/noop';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';

import './TextColor.theme.scss';

function TextColor({ currentOption, options, onChange, onSave, onClose }) {
  const tagLabel = useMemo(() => {
    return options.reduce((title, option) => {
      // eslint-disable-next-line
      if (option.value == currentOption) {
        // eslint-disable-next-line no-param-reassign
        title = option.label;
      }
      return title;
    }, 'Default');
  }, [options, currentOption]);

  return (
    <ProfileSettingsAccordionItem
      onClose={onClose}
      onSave={onSave}
      label={ProfileSettingsConfig.Labels.textColor}
      value={tagLabel}
      title={ProfileSettingsConfig.Labels.textColor}
      titled
      validateOnSave
      className="text-color-accordion-item">
      <div className="text-color-accordion-item__wrapper">
        {options.map((option) => (
          <div className="text-color-accordion-item__option" key={`text-color-${option.value}`}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
              className={cn(
                `text-color-accordion-item__option_panel text-color-accordion-item__option_panel-${option.value}`,
                currentOption === option.value && 'text-color-accordion-item__option_panel-active'
              )}
              onClick={() => onChange('RX2_PAGE_STYLE_TEXT_COLOR', option.value)}>
              <div className="text-color-accordion-item__option_panel_label">
                <b>Reference</b> - Journal Name
              </div>

              <div>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a className="rx-btn rx-btn--basic_link blue rx-btn--right">
                  <span className="rx-btn-text">
                    <span className="rx-btn-text-container">Article Details</span>
                  </span>
                  <span className="rx-btn-icon">
                    <i className="ss-navigateright" />
                  </span>
                </a>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a className="rx-btn rx-btn--basic_link blue">
                  <span>
                    <span className="rx-btn-text">
                      <span className="rx-btn-text-container">Full Text</span>
                    </span>
                    <span className="rx-btn-icon">
                      <i className="ss-upright" />
                    </span>
                  </span>
                </a>
              </div>
            </div>
            <div className="text-color-accordion-item__option_title">{option.value === 'default' ? 'Default' : 'All Black'}</div>
          </div>
        ))}
      </div>
    </ProfileSettingsAccordionItem>
  );
}

TextColor.propTypes = {
  currentOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.array,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

TextColor.defaultProps = {
  options: [],
  onChange: noop,
  onSave: noop,
  onClose: noop,
};

export default TextColor;
